import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = ({ scrollToSection }) => {
  const navigate = useNavigate();

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for subscribing to our newsletter!");
  };

  const quickLinks = [
    { name: "home", path: "/" },
    { name: "about", path: "/about" },
    { name: "Request for quotation", path: "/rfq" },
  ];

  return (
    <footer
      className="footer py-5"
      style={{
        backgroundColor: "var(--secondarytext)",
        color: "var(--canvas)",
      }}
    >
      <div className="container">
        <div className="row">
          {/* Company Info */}
          <div className="col-12 col-md-6 col-lg-6 mb-4">
            <div className="footer-section">
              <div className="footer-logo d-flex align-items-center mb-3">
                <a
                  className="navbar-brand"
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/");
                  }}
                >
                  <img
                    src="../logo.svg"
                    alt="Logo"
                    className="d-inline-block align-text-top me-2"
                    style={{ maxWidth: "100px" }}
                  />
                </a>
              </div>
              <p
                style={{
                  opacity: 0.9,
                  color: "var(--canvas)",
                }}
              >
                Engineering the Next Vision in Technology
              </p>
              <p
                className="copyright mt-4"
                style={{
                  opacity: 0.9,
                  fontSize: "0.9rem",
                  color: "var(--canvas)",
                }}
              >
                © 2025 Vions Tech. All rights reserved.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-6 col-md-3 col-lg-3 mb-4">
            <div className="footer-section">
              <h5 className="mb-3 fw-bold" style={{ color: "var(--card)" }}>
                Quick Links
              </h5>
              <ul className="list-unstyled">
                {quickLinks.map((item) => (
                  <li key={item.name} className="mb-2">
                    <button
                      onClick={() => {
                        navigate(item.path);
                        window.scrollTo({ top: 0, behavior: "smooth" }); // <-- scroll to top
                      }}
                      className="p-0 border-0 bg-transparent text-start"
                      style={{
                        color: "var(--canvas)",
                        opacity: 0.9,
                        transition: "all 0.2s ease",
                        cursor: "pointer",
                        fontWeight: 500,
                      }}
                      onMouseOver={(e) => {
                        e.target.style.opacity = 1;
                        e.target.style.color = "var(--primary-light)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.opacity = 0.9;
                        e.target.style.color = "var(--canvas)";
                      }}
                    >
                      {item.name.charAt(0).toUpperCase() +
                        item.name.slice(1)}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Products */}
          <div className="col-6 col-md-3 col-lg-3 mb-4">
            <div className="footer-section">
              <h5 className="mb-3 fw-bold" style={{ color: "var(--card)" }}>
                Products
              </h5>
              <ul className="list-unstyled">
                {[
                  "Contactless Water Dispenser",
                  "Smart Energy Monitoring Devices",
                  "Smart Facility Monitoring System",
                  "IoT Automation Gateways",
                ].map((product) => (
                  <li key={product} className="mb-2">
                    {product === "Contactless Water Dispenser" ? (
                      <button
                        type="button"
                        onClick={() => navigate("/products/contactless-water-dispenser")}
                        className="p-0 border-0 bg-transparent text-start"
                        style={{
                          color: "var(--canvas)",
                          opacity: 0.9,
                          textDecoration: "none",
                          transition: "all 0.2s ease",
                          fontWeight: 500,
                          cursor: "pointer",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.opacity = 1;
                          e.target.style.color = "var(--primary-light)";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.opacity = 0.9;
                          e.target.style.color = "var(--canvas)";
                        }}
                      >
                        {product}
                      </button>
                    ) : (
                      <a
                        href="#products"
                        style={{
                          color: "var(--canvas)",
                          opacity: 0.9,
                          textDecoration: "none",
                          transition: "all 0.2s ease",
                          fontWeight: 500,
                        }}
                        onMouseOver={(e) => {
                          e.target.style.opacity = 1;
                          e.target.style.color = "var(--primary-light)";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.opacity = 0.9;
                          e.target.style.color = "var(--canvas)";
                        }}
                      >
                        {product}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div
          className="my-4"
          style={{
            height: 1,
            backgroundColor: "rgba(255, 255, 255, 0.3)",
          }}
        ></div>

        {/* Bottom Section */}
        <div className="row align-items-center">
          <div className="col-md-6 mb-3 mb-md-0">
            <div
              style={{
                opacity: 0.9,
                color: "var(--canvas)",
              }}
            >
              <span className="d-inline-block me-3">
                <i className="fas fa-shield-alt me-1"></i> Secure & Reliable
              </span>
              <span className="d-inline-block">
                <i className="fas fa-award me-1"></i> Quality Guaranteed
              </span>
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex justify-content-md-end justify-content-center">
              <div className="col-md-6 text-md-end text-center">
                <div style={{ fontWeight: 500, fontSize: "1.05rem", marginBottom: 8 }}>
                  Follow us at{" "}
                  <a href="https://www.facebook.com/profile.php?id=61580264266614" target="_blank" rel="noopener noreferrer" style={{ color: "#3b5998", margin: "0 4px" }}>
                    <i className="fab fa-facebook-square fa-lg"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/vions-tech/?viewAsMember=true" target="_blank" rel="noopener noreferrer" style={{ color: "#0077b5", margin: "0 4px" }}>
                    <i className="fab fa-linkedin fa-lg"></i>
                  </a>
                  <a href="https://www.instagram.com/vionstech/" target="_blank" rel="noopener noreferrer" style={{ color: "#e4405f", margin: "0 4px" }}>
                    <i className="fab fa-instagram fa-lg"></i>
                  </a>
                  <a href="mailto:connect@vionstech.com" target="_blank" rel="noopener noreferrer" style={{ color: "#dd4b39", margin: "0 4px" }}>
                    <i className="fab fa-google-plus-g fa-lg"></i>
                  </a>
                </div>
                <div style={{ fontWeight: 600, fontSize: "1.1rem", color: "#1976d2" }}>
                  +91-8676038528
                </div>
                <div>
                  <a href="mailto:connect@vionstech.com" style={{ color: "#1976d2", fontWeight: 600, textDecoration: "none" }}>
                    connect@vionstech.com
                  </a>
                </div>
              </div>
              {/*{[
                { icon: "fab fa-linkedin", url: "#" },
                { icon: "fab fa-twitter", url: "#" },
                { icon: "fab fa-facebook", url: "#" },
                { icon: "fab fa-instagram", url: "#" },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="d-flex align-items-center justify-content-center rounded-3 mx-2"
                  style={{
                    width: 40,
                    height: 40,
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                    color: "var(--canvas)",
                    transition: "all 0.3s ease",
                    textDecoration: "none",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "var(--primary)";
                    e.target.style.color = "white";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor =
                      "rgba(255, 255, 255, 0.15)";
                    e.target.style.color = "var(--canvas)";
                  }}
                >
                  <i className={social.icon}></i>
                </a>
              ))}*/}
            </div>
          </div>
        </div>
        {/* Bottom Section 
        <div className="row align-items-center mt-4">
          <div className="col-12 text-center">
            <div style={{ fontWeight: 500, fontSize: "1.05rem", marginBottom: 8 }}>
              Follow us at{" "}
              <a href="https://www.facebook.com/profile.php?id=61580264266614" target="_blank" rel="noopener noreferrer" style={{ color: "#3b5998", margin: "0 4px" }}>
                <i className="fab fa-facebook-square fa-lg"></i>
              </a>
              <a href="https://www.linkedin.com/company/vions-tech/?viewAsMember=true" target="_blank" rel="noopener noreferrer" style={{ color: "#0077b5", margin: "0 4px" }}>
                <i className="fab fa-linkedin fa-lg"></i>
              </a>
              <a href="https://www.instagram.com/vionstech/" target="_blank" rel="noopener noreferrer" style={{ color: "#e4405f", margin: "0 4px" }}>
                <i className="fab fa-instagram fa-lg"></i>
              </a>
              <a href="mailto:info@oasiswfs.in" target="_blank" rel="noopener noreferrer" style={{ color: "#dd4b39", margin: "0 4px" }}>
                <i className="fab fa-google-plus-g fa-lg"></i>
              </a>
            </div>
            <div style={{ fontWeight: 600, fontSize: "1.1rem", color: "#1976d2" }}>
              +91-9990210500
            </div>
            <div>
              <a href="mailto:info@oasiswfs.in" style={{ color: "#1976d2", fontWeight: 600, textDecoration: "none" }}>
                info@oasiswfs.in
              </a>
            </div>
          </div>
        </div>*/}
      </div>
    </footer>
  );
};

export default Footer;
